import { Component, ElementRef, ViewChild } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { SiteGeoMappingService } from '../../Model/LocationMaster/SiteGeoMappng/site-geo-mapping.service';
import { Subject } from 'rxjs';
import { DataTablesModule } from 'angular-datatables';
import * as XLSX from 'xlsx';
import { QRCodeModule } from 'angularx-qrcode';
import jsPDF from 'jspdf';
import QRCode from 'qrcode';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { CommonService } from '../../Model/Common/common.service';
@Component({
  selector: 'app-site-geo-mapping',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, DataTablesModule, QRCodeModule],
  templateUrl: './site-geo-mapping.component.html',
  styleUrl: './site-geo-mapping.component.scss'
})
export class SiteGeoMappingComponent {
  @ViewChild('qrcodeCanvas', { static: false }) qrcodeCanvas!: ElementRef;
  user: any;
  isDisabled: boolean = false;
  BranchMaster: any[] = [];
  ClientLoad: any[] = [];
  SiteLoad: any[] = [];
  SiteGeoMapping: any[] = [];
  rowEnabled: boolean[] = [];
  selectAllRows: boolean = false;

  BranchId: any = null;
  BranchName: string = '';
  ClientId: any = null;
  ClientName: string = '';
  SiteId: any = null;

  SiteName: string = '';
  SiteCode: string = '';
  public User: any = null;
  dtTrigger: Subject<any> = new Subject<any>();
  ID: string = '';
  pdfSiteName: string = '';
  pdfSiteCode: string = '';
  pdfClientName: string = '';
  SiteGeoData: any[] = [];
  SiteGeoMapRecord: any[] = [];
  dtoptions: DataTables.Settings = {};
  IsMultiSiteQR = false;
  constructor(private SiteGeoMapService: SiteGeoMappingService,
    private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private modalService: NgbModal,
    private download: DownloadSampleService,
    protected common: CommonService,
    private tooltip: TooltipService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
  }
  onSelectChange(type: string) {
    if (type === 'Branch') {
      const selected = this.BranchMaster.find(duty => duty.BranchMasterID === this.BranchId);
      this.BranchName = selected ? selected.BranchName : null;
      this.ClientId = null;
      this.ClientName = ''
      this.SiteCode = ''
      this.SiteName = ''
      this.SiteId = null
    }
    else if (type == 'Client') {
      const selected = this.ClientLoad.find(site => site.ClientGroupMasterID === this.ClientId);
      this.ClientName = selected ? selected.ClientGroupName : null;
      this.SiteCode = ''
      this.SiteName = ''
      this.SiteId = null
    }
    else if (type === 'Site') {
      const selected = this.SiteLoad.find(duty => duty.SiteMasterID === this.SiteId);
      this.SiteName = selected ? selected.SiteName : null;
      this.SiteCode = selected ? selected.SiteCode : null;
    }
  }
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.BranchId : 0,
      'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.ClientId : 0,
      'SiteId': (Combotype == 'Designation' || Combotype == 'Duty') ? this.SiteId : 0,
      // 'EmpType': 'front'
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;

        } else if (Combotype == 'Client') {
          this.ClientLoad = response.ComboLoad;

        } else if (Combotype == 'Site') {
          this.SiteLoad = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
      },
    });
  }
  add() {
    if (!this.BranchName || this.BranchName == '' || this.BranchId == 0) {

      this.toast.show({ message: 'Please select Branch !', type: toastTypeEnum.warning });
      return;
    }
    if (!this.ClientName || this.ClientName == '' || this.ClientId == 0) {

      this.toast.show({ message: 'Please select Client !', type: toastTypeEnum.warning });
      return;
    }
    if (!this.SiteLoad || this.SiteLoad.length === 0) {

      this.toast.show({ message: 'No Sites are Avaliable!', type: toastTypeEnum.warning });
      return;
    }
    this.TableFill();
    this.selectAllRows = false;
    this.rowEnabled = new Array(this.SiteGeoMapping.length).fill(false);
  }
  toggleRowEnabled(index: number) {
    this.rowEnabled[index] = !this.rowEnabled[index];
  }
  toggleSelectAllRows() {
    this.selectAllRows = !this.selectAllRows;
    // this.SiteGeoMapping.forEach(shift => shift.checked = this.selectAllRows);
    this.rowEnabled = new Array(this.SiteGeoMapping.length).fill(this.selectAllRows);
    this.SiteGeoMapping.forEach(shift => shift.checked = true);
    if (!this.selectAllRows) {
      this.SiteGeoMapping.forEach(shift => shift.checked = false);
    }
  }

  async save() {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Are you Sure want to save?'

    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsEdit) {
        if (result) {
          this.InsertUpdate();
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {

    });
  }
  TableFill() {
    this.User = this.sessionService.GetUserDetails();
    const SiteGeoMap = {
      UserId: this.User.UserId,
      Type: 'Site',
      BranchId: this.BranchId,
      ClientID: this.ClientId,
      SiteID: this.SiteId
    }
    this.isDisabled = true;
    this.SiteGeoMapService.SiteGeoMapLoad(SiteGeoMap).subscribe(
      data => {
        this.SiteGeoMapping = data
        this.isDisabled = false;
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      }
    );
  }
  InsertUpdate() {
    if (this.SiteGeoMapping.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return
    }
    this.User = this.sessionService.GetUserDetails();
    const SiteGeoMap = this.SiteGeoMapping.map(site => {
      return {
        SiteID: site.SiteID,
        Latitude: site.Latitude,
        Longitude: site.Longitude,
        Accuracy: site.Accuracy,
        Altitude: site.Altitude,
        Heading: site.Heading,
        Radius: site.Radius,
        IsAltitudeApplicable: site.IsAltitudeApplicable,
        AltitudeRadius: site.AltitudeRadius,
        isMocked: true,
        Active: true,
        GeoMappingFor: 'S'
      };
    });
    console.log(SiteGeoMap);
    const SiteData = {
      UserId: this.User.UserId,
      Type: 'Site',
      SiteGeoMappingParameter: SiteGeoMap
    };
    this.SiteGeoMapService.SiteGeoMapInsertUpate(SiteData).subscribe(
      data => {
        if (data.Error_Code == 1) {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.warning });
        }
        this.SiteGeoMapping = [];
        this.SiteLoad = [];
        this.ClientLoad = [];
        this.SiteId = null;
        this.SiteName = '';
        this.SiteCode = '';
        this.BranchId = null;
        this.ClientId = null;
      },
      error => {
        console.error('Error:', error);
      });
  }

  ValidateInput(event: KeyboardEvent, type: string) {
    const charCode = event.which ? event.which : event.keyCode;
    const input = (event.target as HTMLInputElement).value;
    const dotCount = input.split('.').length - 1;
    const minusCount = (input.match(/-/g) || []).length;
    const cursorPosition = (event.target as HTMLInputElement).selectionStart;

    if (type === 'Latitude') {
      if (
        (charCode !== 46 && charCode !== 45 && (charCode < 48 || charCode > 57)) ||
        (dotCount > 0 && charCode === 46 && (cursorPosition !== null && cursorPosition <= input.indexOf('.') + 1)) ||
        (charCode === 45 && (cursorPosition !== null && cursorPosition !== 0)) ||
        (minusCount > 0 && charCode === 45)
      ) {
        event.preventDefault();
        return;
      }
      if (input.length >= 25) {
        event.preventDefault();
        return;
      }
    }
    else if (type === 'NumandDec') {
      if (
        (charCode !== 46 && charCode !== 45 && (charCode < 48 || charCode > 57)) ||
        (dotCount > 0 && charCode === 46 && (cursorPosition !== null && cursorPosition <= input.indexOf('.') + 1)) ||
        (charCode === 45 && (cursorPosition !== null && cursorPosition !== 0)) ||
        (minusCount > 0 && charCode === 45)
      ) {
        event.preventDefault();
        return;
      }
    }
    else if (type === 'radius') {
      if (
        charCode !== 46 &&
        charCode > 31 &&
        (charCode < 48 || charCode > 57) ||
        (dotCount > 0 && charCode === 46)
      ) {
        event.preventDefault();
      }
    }
  }
  handleFileInput(event: any): void {
    this.SiteGeoMapRecord.length = 0;
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      const file: File = files[0];
      const fileType: string | undefined = file.name.split('.').pop();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
        return;
      }
      this.processExcelFile(file);
      event.target.value = '';
    }
  }
  // processExcelFile(file: File): void {
  //   const reader = new FileReader();
  //   reader.onload = (event) => {
  //     if (event && event.target && event.target.result) {
  //       const binaryString = event.target.result as string;
  //       const workbook = XLSX.read(binaryString, { type: 'binary' });
  //       const sheetName = workbook.SheetNames[0];
  //       const worksheet = workbook.Sheets[sheetName];
  //       const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
  //       const headerRow = excelData[0];
  //       const headers = headerRow.map((header: string) => header.trim());
  //       const dataRows = excelData.slice(1);
  //       const formattedData = dataRows.map((row: any[]) => {
  //         const rowData: any = {};
  //         row.forEach((cellData, index) => {
  //           rowData[headers[index]] = cellData;
  //         });
  //         return rowData;
  //       });
  //       const invalidRowsWithDetails = formattedData.filter((row, rowIndex) => {
  //         let invalidColumns: string[] = [];
  //         for (const column of ['Latitude', 'Longitude', 'Accuracy', 'Altitude', 'Heading', 'Radius']) {
  //           if (typeof row[column] === 'string') {
  //             invalidColumns.push(column);
  //           }
  //         }
  //         if (invalidColumns.length > 0) {
  //           const errorMessage = `Invalid row at index ${rowIndex + 1}: Invalid column - ${invalidColumns.join(', ')}`;
  //           this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
  //           return true;
  //         }
  //         return false;
  //       });
  //       if (invalidRowsWithDetails.length > 0) {
  //         return;
  //       }
  //       this.SiteGeoMapRecord = [];
  //       formattedData.forEach(row => {
  //         this.SiteGeoMapRecord.push(row);
  //       });
  //       console.log('Excel data:', this.SiteGeoMapRecord);
  //     } else {
  //       console.error('Failed to read the file.');
  //     }
  //   };
  //   reader.readAsBinaryString(file);
  // }
  processExcelFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = 'Sheet1';
        if (!workbook.SheetNames.includes(sheetName)) {
          const errorMessage = 'Sheet1 not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        const headerRow = excelData[0];
        const headers = headerRow.map((header: string) => header.trim());
        const dataRows = excelData.slice(1);
        const uniqueIds: Set<number> = new Set();
        //const uniqueLocationIds: Set<number> = new Set();
        // const LocationNames: Set<string> = new Set();
        this.SiteGeoMapRecord = [];

        for (let rowIndex = 0; rowIndex < dataRows.length; rowIndex++) {
          const row = dataRows[rowIndex];
          const rowData: any = {};

          row.forEach((cellData, index) => {
            rowData[headers[index]] = cellData;
          });

          //const id = rowData['ESS_SiteGateGeoMappingID'];
          // let branchname = rowData['BranchName'].toString();
          // let clientname = rowData['ClientName'].toString();
          let sitecode = rowData['SiteCode'].toString();
          let sitename = rowData['SiteName'].toString();
          let isaltitudeapplicable = rowData['IsAltitudeApplicable'].toString();
          let altituderadius = rowData['AltitudeRadius']

          // branchname = branchname ? branchname.trim() : '';
          // clientname = clientname ? clientname.trim() : '';
          sitecode = sitecode ? sitecode.trim() : '';
          sitename = sitename ? sitename.trim() : '';

          if (sitecode !== '' && sitecode !== undefined && uniqueIds.has(sitecode)) {
            this.toast.show({ message: `Duplicate Site Code '${sitecode}' found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          } else {
            uniqueIds.add(sitecode);
          }

          // if (branchname === '' || branchname === null || branchname === undefined) {
          //   this.toast.show({ message: `Branch name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
          //   return;
          // }

          // if (clientname === '' || clientname === null || clientname === undefined) {
          //   this.toast.show({ message: `Client name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
          //   return;
          // }
          if (sitecode === '' || sitecode === null || sitecode === undefined) {
            this.toast.show({ message: `Site Code is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          if (sitename === '' || sitename === null || sitename === undefined) {
            this.toast.show({ message: `Site name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          // rowData['BranchName'] = branchname;
          // rowData['ClientName'] = clientname;
          rowData['SiteCode'] = sitecode;
          rowData['SiteName'] = sitename;
          rowData['IsMocked'] = true;
          rowData['Active'] = true;
          rowData['GeoMappingFor'] = 'S';
          rowData['IsAltitudeApplicable'] = isaltitudeapplicable.toLowerCase() == 'yes' ? true : false;
          rowData['AltitudeRadius'] = altituderadius;
          this.SiteGeoMapRecord.push(rowData);
          console.log(this.SiteGeoMapRecord)
        }
        this.BulkInsertUpdate(this.SiteGeoMapRecord);
      } else {
        console.error('Failed to read the file.');
      }
    };
    reader.readAsBinaryString(file);
  }
  BulkInsertUpdate(Data: any) {
    this.User = this.sessionService.GetUserDetails();
    if (this.SiteGeoMapRecord.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return
    }
    const shiftgroupData = {
      SelectType: 'UPLOAD',
      ESS_SiteGeoMappingBulkInsertUpdate: Data,
      UserId: this.User.UserId,
    };
    this.isDisabled = true;
    this.SiteGeoMapService.ESS_SiteGeoMapping_BlukInsert(shiftgroupData).subscribe(
      data => {
        if (data.Error_Code == '620') {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.danger });
        }
        this.isDisabled = false;
        //this.GetData();
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      });
  }
  downloadExcel() {
    this.download.downloadExcel('SiteGeoMappingUpload');
  }
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
  }

  generateQRCodeAndDownloadPDF(element: any): void {
    // this.ID = element.SiteID;

    // this.pdfSiteName = element.SiteName;
    // this.pdfClientName = element.ClientName;
    if (element != null) {
      this.IsMultiSiteQR = false;
      this.pdfSiteCode = element.SiteCode;
      this.QRGenerate(element.SiteID);
    } else {
      if (this.SiteGeoMapping.filter(e => e.checked).length > 0) {
        this.IsMultiSiteQR = true;
        this.QRGenerate('0');
      } else {
        this.toast.show({ message: 'Please select check box!', type: toastTypeEnum.warning });
      }

    }
  }

  QRGenerate(SiteID: string) {

    const QRData = {
      //SiteMasterIDs: SiteID,
      SiteMasterIDs: !this.IsMultiSiteQR ? SiteID : this.SiteGeoMapping.filter(e => e.checked).map(e => e.SiteID).toString(),
      DateOfGeneration: new Date(),
      WithoutJSON: 0
    };
    this.SiteGeoMapService.GETSiteWisQRcode(QRData).subscribe(
      data => {
        const qrCodeValue = data.Table.map((e: any) => e.QRcodeValue);
        const companyName = data.Table1[0].CompanyName;
        this.createPDFWithQRCode(qrCodeValue, companyName);
      },
      error => {
        console.error('Error:', error);
      }
    );
  }
  // createPDFWithQRCode(qrCodeUrl: string, companyName: string): void {
  //   const companyNameText = companyName.replace(/<\/?[^>]+(>|$)/g, "");
  //   QRCode.toDataURL(qrCodeUrl, { errorCorrectionLevel: 'H' }, (err: any, url: string) => {
  //     if (err) {
  //       console.error(err);
  //       return;
  //     }
  //     const pdfWidth = 150;
  //     const pdfHeight = 150;

  //     const pdf = new jsPDF({
  //       orientation: 'p',
  //       unit: 'mm',
  //       format: [pdfWidth, pdfHeight]
  //     });
  //     pdf.setFontSize(17);
  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     // const textWidth = pdf.getTextWidth(companyNameText);
  //     // const textX = (pageWidth - textWidth) / 2;
  //     // pdf.text(companyNameText, textX, 20);
  //     const maxLineWidth = pageWidth - 10; // Leave some padding -- To keep company name in next line if it is long
  //     const companyNameLines = pdf.splitTextToSize(companyNameText, maxLineWidth);
  //     let textY = 20; // initial Y position

  //     // Draw each line of the company name and center it
  //     for (const line of companyNameLines) {
  //         const textWidth = pdf.getTextWidth(line);
  //         const textX = (pageWidth - textWidth) / 2; // Center the text
  //         pdf.text(line, textX, textY);
  //         textY += 10; // Move down for the next line
  //     } 
  //     const img = new Image();
  //     img.src = url;
  //     img.onload = () => {
  //       const imgWidth = 60;
  //       const imgHeight = 60;
  //       const imgX = (pageWidth - imgWidth) / 2;
  //       const imgY = 30;
  //       pdf.addImage(img, 'PNG', imgX, imgY, imgWidth, imgHeight);

  //       const siteCodeText = this.pdfSiteCode || "Site Code not available";
  //       const siteNameText = this.pdfSiteName || "Site Name not available";
  //       const clientNameText = this.pdfClientName || "Client Name not available";

  //       pdf.setFontSize(8);

  //       const siteCodeTextWidth = pdf.getTextWidth(siteCodeText);
  //       const siteCodeTextX = (pageWidth - siteCodeTextWidth) / 2;
  //       const siteCodeTextY = imgY + imgHeight + 5;
  //       pdf.text(siteCodeText, siteCodeTextX, siteCodeTextY);

  //       const clientNameTextWidth = pdf.getTextWidth(clientNameText);
  //       const clientNameTextX = (pageWidth - clientNameTextWidth) / 2;
  //       const clientNameTextY = siteCodeTextY + 5;
  //       pdf.text(clientNameText, clientNameTextX, clientNameTextY);

  //       const siteNameTextWidth = pdf.getTextWidth(siteNameText);
  //       const siteNameTextX = (pageWidth - siteNameTextWidth) / 2;
  //       const siteNameTextY = clientNameTextY + 5;
  //       pdf.text(siteNameText, siteNameTextX, siteNameTextY);

  //       const poweredByText = "Powered by";
  //       const poweredByTextWidth = pdf.getTextWidth(poweredByText);
  //       const poweredByTextAndLogoWidth = poweredByTextWidth + 50;
  //       const poweredByTextAndLogoX = pageWidth - poweredByTextAndLogoWidth;
  //       const poweredByTextAndLogoY = siteNameTextY + 15;
  //       pdf.text(poweredByText, poweredByTextAndLogoX, poweredByTextAndLogoY);

  //       const logoImg = new Image();
  //       logoImg.src = 'assets/maxuslogo.png';
  //       logoImg.onload = () => {
  //         const logoWidth = 30;
  //         const logoHeight = 10;
  //         const logoX = poweredByTextAndLogoX + poweredByTextWidth + 1;
  //         const logoY = poweredByTextAndLogoY - 7;
  //         pdf.addImage(logoImg, 'PNG', logoX, logoY, logoWidth, logoHeight);

  //         const pdfOutput = pdf.output('blob');
  //         const pdfUrl = URL.createObjectURL(pdfOutput);
  //         const a = document.createElement('a');
  //         a.href = pdfUrl;
  //         a.download = 'qrcode_' + this.pdfSiteCode + '.pdf';
  //         a.click();
  //         URL.revokeObjectURL(pdfUrl);
  //       };
  //     };
  //   });
  // }

  async createPDFWithQRCode(qrCodeUrls: string[], companyName: string): Promise<void> {
    const companyNameText = companyName.replace(/<\/?[^>]+(>|$)/g, "");

    // Generate all QR codes first
    const qrPromises = qrCodeUrls.map((url, index) => {
      return new Promise<{ url: string, dataUrl: string, index: number }>((resolve, reject) => {
        QRCode.toDataURL(url, { errorCorrectionLevel: 'H' }, (err: any, dataUrl: string) => {
          if (err) {
            reject(err);
          } else {
            resolve({ url, dataUrl, index });
          }
        });
      });
    });

    try {
      const qrCodes = await Promise.all(qrPromises);

      // Create PDF with multiple pages
      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: [160, 160]
      });

      // Create each page synchronously
      for (let i = 0; i < qrCodes.length; i++) {
        if (i > 0) {
          pdf.addPage();
        }

        await this.createSinglePage(pdf, companyNameText, qrCodes[i], i, qrCodes.length);
      }

      // Download PDF
      this.downloadPDF(pdf);

    } catch (error) {
      console.error('Error creating PDF:', error);
    }
  }

  private async createSinglePage(
    pdf: jsPDF,
    companyNameText: string,
    qrCode: { url: string, dataUrl: string, index: number },
    pageIndex: number,
    totalPages: number
  ): Promise<void> {
    return new Promise((resolve) => {
      const pageWidth = pdf.internal.pageSize.getWidth();
      // Company Name
      pdf.setFontSize(17);
      const maxLineWidth = pageWidth - 10;
      const companyNameLines = pdf.splitTextToSize(companyNameText, maxLineWidth);

      let textY = 20;
      for (const line of companyNameLines) {
        const textWidth = pdf.getTextWidth(line);
        const textX = (pageWidth - textWidth) / 2;
        pdf.text(line, textX, textY);
        textY += 10;
      }

      // Load and add QR code image
      const img = new Image();
      img.src = qrCode.dataUrl;

      img.onload = () => {
        const imgWidth = 60;
        const imgHeight = 60;
        const imgX = (pageWidth - imgWidth) / 2;
        const imgY = textY + 2; // Gap after company name

        pdf.addImage(img, 'PNG', imgX, imgY, imgWidth, imgHeight);

        // Add details below QR code
        this.addDetailsToPage(pdf, pageWidth, imgY + imgHeight, pageIndex, totalPages, JSON.parse(qrCode.url));

        resolve();
      };

      img.onerror = () => {
        console.error('Failed to load QR code image');
        resolve();
      };
    });
  }

  private addDetailsToPage(
    pdf: jsPDF,
    pageWidth: number,
    startY: number,
    pageIndex: number,
    totalPages: number,
    jsonDetail: any
  ): void {
    // QR Code Label
    pdf.setFontSize(8);
    const qrLabel = `QR Code ${pageIndex + 1}`;
    const qrLabelWidth = pdf.getTextWidth(qrLabel);
    const qrLabelX = (pageWidth - qrLabelWidth) / 2;
    //pdf.text(qrLabel, qrLabelX, startY + 5);

    // Site Code
    const siteCodeText = jsonDetail.SiteCode || "Site Code not available";
    const siteCodeWidth = pdf.getTextWidth(siteCodeText);
    const siteCodeX = (pageWidth - siteCodeWidth) / 2;
    pdf.text(siteCodeText, siteCodeX, startY + 12);

    // Client Name
    const clientNameText = jsonDetail.ClientName || "Client Name not available";
    const clientNameWidth = pdf.getTextWidth(clientNameText);
    const clientNameX = (pageWidth - clientNameWidth) / 2;
    pdf.text(clientNameText, clientNameX, startY + 19);

    // Site Name
    const siteNameText = jsonDetail.SiteName || "Site Name not available";
    const siteNameWidth = pdf.getTextWidth(siteNameText);
    const siteNameX = (pageWidth - siteNameWidth) / 2;
    pdf.text(siteNameText, siteNameX, startY + 26);

    // Page Number
    pdf.setFontSize(10);
    const pageNumberText = `Page ${pageIndex + 1} of ${totalPages}`;
    const pageNumberWidth = pdf.getTextWidth(pageNumberText);
    const pageNumberX = (pageWidth - pageNumberWidth) / 2;
    const pageHeight = pdf.internal.pageSize.getHeight();
    pdf.text(pageNumberText, pageNumberX, pageHeight - 10);

    // Powered by logo on last page only
    if (pageIndex === totalPages - 1) {
      this.addPoweredByLogo(pdf, pageWidth, startY + 35);
    }
  }

  private addPoweredByLogo(pdf: jsPDF, pageWidth: number, startY: number): void {
    const logoImg = new Image();
    logoImg.src = 'assets/maxuslogo.png';

    logoImg.onload = () => {
      pdf.setFontSize(8);
      const poweredByText = "Powered by";
      const poweredByWidth = pdf.getTextWidth(poweredByText);
      const totalWidth = poweredByWidth + 35;
      const startX = (pageWidth - totalWidth) / 2;

      pdf.text(poweredByText, startX, startY);

      const logoWidth = 30;
      const logoHeight = 10;
      const logoX = startX + poweredByWidth + 5;
      const logoY = startY - 7;
      pdf.addImage(logoImg, 'PNG', logoX, logoY, logoWidth, logoHeight);
    };
  }

  private downloadPDF(pdf: jsPDF): void {
    const pdfOutput = pdf.output('blob');
    const pdfUrl = URL.createObjectURL(pdfOutput);
    const a = document.createElement('a');
    a.href = pdfUrl;
    if (this.IsMultiSiteQR) {
      a.download = `qrcode_multiple.pdf`;
    } else {
      a.download = `qrcode_${this.pdfSiteCode}.pdf`;
    }

    a.click();
    URL.revokeObjectURL(pdfUrl);
  }

  createPDFWithQRCode2(qrCodeUrl: any, companyName: string): void {
    const companyNameText = companyName.replace(/<\/?[^>]+(>|$)/g, "");
    QRCode.toDataURL(qrCodeUrl, { errorCorrectionLevel: 'H' }, (err: any, url: string) => {
      if (err) {
        console.error(err);
        return;
      }
      const pdfWidth = 160;
      const pdfHeight = 160;

      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: [pdfWidth, pdfHeight]
      });

      pdf.setFontSize(17);
      const pageWidth = pdf.internal.pageSize.getWidth();
      const maxLineWidth = pageWidth - 10; // Leave some padding
      const companyNameLines = pdf.splitTextToSize(companyNameText, maxLineWidth);

      let textY = 20; // Initial Y position

      // Draw each line of the company name and center it
      for (const line of companyNameLines) {
        const textWidth = pdf.getTextWidth(line);
        const textX = (pageWidth - textWidth) / 2; // Center the text
        pdf.text(line, textX, textY);
        textY += 10; // Move down for the next line
      }

      // Define a gap between company name and QR code
      const gap = 2; // Fixed space in mm
      const imgY = textY + gap; // Adjust the Y position for the image with the gap

      const img = new Image();
      img.src = url;
      img.onload = () => {
        const imgWidth = 60;
        const imgHeight = 60;
        const imgX = (pageWidth - imgWidth) / 2;
        pdf.addImage(img, 'PNG', imgX, imgY, imgWidth, imgHeight);

        const siteCodeText = this.pdfSiteCode || "Site Code not available";
        const siteNameText = this.pdfSiteName || "Site Name not available";
        const clientNameText = this.pdfClientName || "Client Name not available";

        pdf.setFontSize(8);

        const siteCodeTextWidth = pdf.getTextWidth(siteCodeText);
        const siteCodeTextX = (pageWidth - siteCodeTextWidth) / 2;
        const siteCodeTextY = imgY + imgHeight + 5;
        pdf.text(siteCodeText, siteCodeTextX, siteCodeTextY);

        const clientNameTextWidth = pdf.getTextWidth(clientNameText);
        const clientNameTextX = (pageWidth - clientNameTextWidth) / 2;
        const clientNameTextY = siteCodeTextY + 5;
        pdf.text(clientNameText, clientNameTextX, clientNameTextY);

        const siteNameTextWidth = pdf.getTextWidth(siteNameText);
        const siteNameTextX = (pageWidth - siteNameTextWidth) / 2;
        const siteNameTextY = clientNameTextY + 5;
        pdf.text(siteNameText, siteNameTextX, siteNameTextY);

        const poweredByText = "Powered by";
        const poweredByTextWidth = pdf.getTextWidth(poweredByText);
        const poweredByTextAndLogoWidth = poweredByTextWidth + 50;
        const poweredByTextAndLogoX = pageWidth - poweredByTextAndLogoWidth;
        const poweredByTextAndLogoY = siteNameTextY + 15;
        pdf.text(poweredByText, poweredByTextAndLogoX, poweredByTextAndLogoY);

        const logoImg = new Image();
        logoImg.src = 'assets/maxuslogo.png';
        logoImg.onload = () => {
          const logoWidth = 30;
          const logoHeight = 10;
          const logoX = poweredByTextAndLogoX + poweredByTextWidth + 1;
          const logoY = poweredByTextAndLogoY - 7;
          pdf.addImage(logoImg, 'PNG', logoX, logoY, logoWidth, logoHeight);


          // const pdfOutput = pdf.output('blob');
          // const pdfUrl = URL.createObjectURL(pdfOutput);
          // const a = document.createElement('a');
          // a.href = pdfUrl;
          // a.download = 'qrcode_' + this.pdfSiteCode + '.pdf';
          // a.click();
          // URL.revokeObjectURL(pdfUrl);
        };
      };
    });
  }

  exportToExcel() {
    this.isDisabled = true
    const data = {
      SelectType: 'SiteGeoMappingMasterExcel',
      Year: ''
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.SiteGeoData = data;
        if (this.SiteGeoData.length > 0) {
          this.download.exportToExcel(this.SiteGeoData, "SiteGeoMapping_data");
          this.isDisabled = false
        }
        else {
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }
      }
    );
  }

  disableAltitude(row: boolean, altitude: boolean): boolean {
    if (row) {
      if (altitude) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  }

  Clear() {
    this.SiteGeoMapping = [];
  }
}

